import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { jobConstants } from '..';

export const useJobCanceAction = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (id?: number) => {
      const res = await $api.post(`/v1/job/cancel-action/${id}`);

      return res?.data?.data;
    },
    onSuccess: async () => {
      await qc.invalidateQueries([jobConstants.queryKeys.JOB_RESULT]);
    }
  });
};
